/**
 * Zentrale Konstanten und Dokumentation für den DATEV-Wizard.
 *
 * ## Architekturentscheidungen
 *
 * ### ARCHITEKTURENTSCHEIDUNG: Zwei Actions für Client-ID (setClientId vs syncClientIdFromRoute)
 *
 * Problem: Bei Deep-Links zur export-date Seite wurde die Client-ID aus der Route gelesen
 * und via setClientId dispatcht. setClientId triggert aber einen Effect, der prüft ob
 * eine Config existiert und ggf. zur config-exists Seite navigiert → Endlos-Loop.
 *
 * Lösung: Zwei separate Actions:
 * - `setClientId`: Für User-Eingaben, triggert Navigation-Effects
 * - `syncClientIdFromRoute`: Für Route-Sync, triggert KEINE Navigation
 *
 * Regel: Komponenten die IDs aus der Route lesen (nicht client-id Seite selbst)
 * müssen `syncClientIdFromRoute` verwenden.
 *
 * ## Gemeinsame Patterns (Single Source of Truth)
 *
 * ### Store-zu-FormControl Synchronisation
 * Effects und Subscriptions, die Store-Werte in FormControls synchronisieren,
 * müssen Endlosschleifen vermeiden:
 * 1. Wertvergleich: Nur synchronisieren wenn sich der Wert tatsächlich geändert hat
 * 2. emitEvent: false verwenden um valueChanges Events zu unterdrücken
 * 3. Touched-State wiederherstellen nach setValue
 *
 * ### Checkbox-gesteuertes Datumsfeld
 * Das Datumsfeld wird durch eine "datumsunabhängig"-Checkbox gesteuert:
 * - Bei Aktivierung: Letzten Datumswert zwischenspeichern, Feld leeren und deaktivieren
 * - Bei Deaktivierung: Feld wieder aktivieren, gespeicherten Wert wiederherstellen
 *
 * ### Deep-Link Unterstützung
 * Alle Wizard-Komponenten unterstützen Deep-Links durch Synchronisation von Route-Parametern.
 * Bei Navigation direkt zu einem Schritt werden firmenId, clientId und fall aus der URL gelesen
 * und in den Store dispatcht.
 */

/**
 * Default-Name für Export-Konfigurationen.
 * Wird verwendet wenn kein spezifischer Name vorhanden ist oder beim initialen Erstellen.
 */
export const DEFAULT_EXPORT_CONFIG_NAME = 'DATEV-Export-Konfiguration';

/**
 * Generische Fehlermeldung für OAuth-Fehler ohne Beschreibung.
 * Wird verwendet wenn DATEV nur einen error-Code ohne error_description zurückgibt.
 */
export const DEFAULT_OAUTH_ERROR_DESCRIPTION = 'Ein Fehler ist aufgetreten.';
